import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react';
import {NavItem, Row, Col, Container} from 'reactstrap';
import {isMobileOnly as isMobile, isTablet} from 'react-device-detect';
import images from './images/images';
import AbroadPackageTab from '../Shared/Components/AbroadPackageTab';

const TabViewIfSelectedPackageExistsComponent = (props) => {
  return (
    <NavItem className={`tab-button custom-tab from-package-tab text-center d-flex flex-wrap align-items-center`}>
      <Container>
        <Row>
          <Col
            className={`${
              isMobile || (isTablet && props.isPortrait) || props.isSmallResolution ? 'col-12' : 'col-3'
            } from-package-tab-icon`}>
            <Image src={images.fromPackage}
              alt='icon'
              className={`${isMobile || (isTablet && props.isPortrait) || props.isSmallResolution ? 'm-auto' : ''}`} />
          </Col>
          <Col
            className={`${isMobile || (isTablet && props.isPortrait) || props.isSmallResolution ? 'col-12 pl-0 pr-0' : 'col-9 pl-0 pr-2'}`}>
            <AbroadPackageTab packageData={props.selectedPackage} supportedApps={props.supportedApps} context={props.context} />
            <div className='clear-selected-package' onClick={() => props.clearSelectedAbroadPackage()}>
              <Image src={images.close} alt='icon' />
            </div>
          </Col>
        </Row>
      </Container>
    </NavItem>
  );
};

export default TabViewIfSelectedPackageExistsComponent;
